module.exports = __webpack_public_path__ + "img/verified_badge.e0f2c710.svg";